import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserDataContext } from "../context/User";

const ProtectedRoute = ({ children, allowedRoles = [], onUnauthorized }) => {
  const { userData, isInitialized } = useContext(UserDataContext);
  const location = useLocation();

  // Show loading state while checking authentication
  if (!isInitialized) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // If no user, trigger unauthorized callback and redirect
  if (!userData) {
    if (onUnauthorized) {
      onUnauthorized();
    }
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // If allowedRoles are specified, check user role
  if (allowedRoles.length > 0 && !allowedRoles.includes(userData.role)) {
    return <Navigate to="/" replace />;
  }

  // If user exists and role is allowed, render the protected component
  return children;
};

export default ProtectedRoute;
